<div
    class="coming-soon-area bg-white"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="row mr-0 mr-0 mb-25">
        <div class="pl-0 pr-0">
            <div class="coming-soon-right text-center position-relative">
                <div class="d-table">
                    <div class="d-table-cell">
                        <a routerLink="/" class="logo">
                            <img src="images/rts-logo.svg" alt="logo">
                            <!-- <span >Risskov Teknik og Solar</span> -->
                        </a>
                        <span class="sub-title d-block">
                            Website is under maintenance
                        </span>
                        <h1 class="fw-bold lh-1">
                            WE ARE LAUNCHING SOON
                        </h1>
                        <button mat-button type="button" class="daxa mt-3 mat-subtitle-1">
                            <a href="https://www.figma.com/design/QbNjfZu3v8bnJLCiSpNVuK/Dashboard-resaerch?node-id=0-1&t=p8qf5x54Rd2p7bAN-1" target="_blank" class="btn btn-primary">
                                Figma Design
                            </a>
                        </button>
                    </div>
                </div>
                <img src="images/coming-soon/shape1.png" class="shape1" alt="shape1">
                <img src="images/coming-soon/shape2.png" class="shape2" alt="shape2">
                <img src="images/coming-soon/shape3.png" class="shape3" alt="shape3">
                <img src="images/coming-soon/shape4.png" class="shape4" alt="shape4">
                <img src="images/coming-soon/shape5.png" class="shape5" alt="shape5">
                <img src="images/coming-soon/shape6.png" class="shape6" alt="shape6">
            </div>
        </div>
    </div>
</div>